import React from "react";
import {
  Button,
  TextField,
  Grid,
  Box,
  Divider,
  Dialog,
  DialogTitle,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AddVendor = ({
  openDialog,
  handleClose,
  typeList,
  register,
  errors,
  formData,
  onAddEditVendorSubmit,
  handleSubmit,
  isEditMode,
  handleChange,
  checked,
  handleTypeChange,
  checkType,
  checkTypeOnEdit,
  isUpdateButton,
  setIsUpdateButton,
  setValue
}) => {
  return (
    <>
      <Dialog open={openDialog} onClose={handleClose} fullWidth={1}
        maxWidth={"xs"}>
        <DialogTitle
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <b>
                {!isEditMode
                  ? "Add Supplier and Vendor"
                  : "Edit Supplier and Vendor"}
              </b>
            </div>
            <CloseIcon
              className="pageHeader"
              onClick={handleClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 2 }}>
              <Box>
                <form>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="left"
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={12}>
                      <TextField
                        className="stepperFormInput"
                        label="User Code"
                        name="code"
                        fullWidth
                        placeholder="Enter user code"
                        size="small"
                        defaultValue={formData.code}
                        required
                        autoComplete="off"
                        {...register("code", { required: true })}
                        error={Boolean(errors?.code)}
                        helperText={errors?.code?.message}
                        onChange={() => setIsUpdateButton(false)}
                        onBlur={(e) => {
                          let str = e.target.value;
                          setValue("code", str.trim());
                         
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        className="stepperFormInput"
                        label="Name"
                        name="name"
                        placeholder="Enter name"
                        fullWidth
                        required
                        size="small"
                        autoComplete="off"
                        {...register("name", { required: true })}
                        error={Boolean(errors?.name)}
                        helperText={errors?.name?.message}
                        onChange={() => setIsUpdateButton(false)}
                        onBlur={(e) => {
                          let str = e.target.value;
                          setValue("name", str.trim());
                         
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth>
                        <InputLabel
                          id="Type-select-label"
                          sx={{ marginTop: "-6px" }}
                        >
                          Type{" "}
                        </InputLabel>
                        <Select
                          className="stepperFormInput"
                          label="Type"
                          name="typeId"
                          fullWidth
                          required
                          defaultValue={formData.typeId}
                          size="small"
                          autoComplete="off"
                          {...register("typeId", { required: true })}
                          error={errors?.typeId}
                          helperText={errors?.typeId?.message}
                          onChange={() => setIsUpdateButton(false)}
                        >
                          {typeList &&
                            typeList.map((r) => {
                              return (
                                <MenuItem
                                  native
                                  key={r.vendorTypeId}
                                  sx={{ width: "100%" }}
                                  value={r.vendorTypeId}
                                  size="small"
                                  onClick={() =>
                                    handleTypeChange(r.vendorTypeId, r.name)
                                  }
                                >
                                  {r.name}
                                </MenuItem>
                              );
                            })} 
                        </Select>                     
                        <FormHelperText sx={{ color: "#d32f2f" }}>
                          {errors && errors?.typeId?.message}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    {checkType === 2 ||
                    (parseInt(formData.typeId) === 2 &&
                      checkTypeOnEdit === 2) ? (
                      <Grid>
                        <FormControlLabel
                          label="Repair Vendor?"
                          control={
                            <Checkbox
                              checked={checked}
                              onChange={(e) => {
                                handleChange(e);
                                setIsUpdateButton(false);
                              }}
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          }
                        />
                      </Grid>
                    ) : null}
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth>
                        <InputLabel
                          id="Active-select-label"
                          sx={{ marginTop: "-6px" }}
                        >
                          Is Active?
                        </InputLabel>
                        <Select
                          className="stepperFormInput"
                          label="Is Active?"
                          name="active"
                          fullWidth
                          // required
                          size="small"
                          defaultValue={
                            Object.prototype.hasOwnProperty.call(
                              formData,
                              "active"
                            )
                              ? Boolean(formData.active)
                              : true
                          }
                          autoComplete="off"
                          {...register("active")}
                          onChange={() => setIsUpdateButton(false)}
                        >
                          <MenuItem
                            native
                            sx={{ width: "100%" }}
                            value={true}
                            selected
                            size="small"
                          >
                            Yes
                          </MenuItem>
                          <MenuItem
                            native
                            sx={{ width: "100%" }}
                            value={false}
                            size="small"
                          >
                            No
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
            <Divider />
            <React.Fragment>
              <Box sx={{ display: "flex", flexDirection: "row", p: 2, pl: 37 }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit(onAddEditVendorSubmit)}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                  disabled={isUpdateButton && isEditMode}
                >
                  {!isEditMode ? "Save" : "Update"}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                >
                  Cancel
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default AddVendor;
